import { render, staticRenderFns } from "./commentsFilterModal.vue?vue&type=template&id=66acc5ae&scoped=true"
import script from "./commentsFilterModal.vue?vue&type=script&lang=js"
export * from "./commentsFilterModal.vue?vue&type=script&lang=js"
import style0 from "./commentsFilterModal.vue?vue&type=style&index=0&id=66acc5ae&prod&lang=scss&scoped=true"
import style1 from "./commentsFilterModal.vue?vue&type=style&index=1&id=66acc5ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66acc5ae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VCard: require('/app/node_modules/vuetify/lib/components/VCard/VCard.js').default,VDialog: require('/app/node_modules/vuetify/lib/components/VDialog/VDialog.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
